module.exports = __webpack_public_path__ + "static/media/exclusivePlusicon.f9708033.png";